//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    notes: Boolean
  }
}
